import { ApiError } from './httpClientFactory';
import { apiClient } from './client';
import type { MeResponse } from './generated';

export type PrincipalKind = Required<MeResponse>['kind'];

/** cnp-api `GET /me` — only the fields the workspace uses. */
export type Me = Required<
  Pick<MeResponse, 'displayName' | 'displayEmail' | 'kind' | 'active' | 'tenantSlug'>
>;

const KINDS: readonly PrincipalKind[] = ['CUSTOMER', 'STAFF', 'SUPPORT'];

export async function getMe(): Promise<Me> {
  const res = await apiClient.get<unknown>('/me');
  const b = res.data as Record<string, unknown> | null;
  if (
    !b ||
    typeof b !== 'object' ||
    typeof b.displayName !== 'string' ||
    b.displayName.length === 0 ||
    typeof b.kind !== 'string' ||
    !KINDS.includes(b.kind as PrincipalKind) ||
    typeof b.active !== 'boolean' ||
    typeof b.tenantSlug !== 'string'
  ) {
    throw new ApiError('INVALID_RESPONSE', res.status);
  }
  return {
    displayName: b.displayName,
    displayEmail: typeof b.displayEmail === 'string' ? b.displayEmail : null,
    kind: b.kind as PrincipalKind,
    active: b.active,
    tenantSlug: b.tenantSlug,
  };
}
